import { render, staticRenderFns } from "./ActivityNew.vue?vue&type=template&id=42338830&scoped=true&"
import script from "./ActivityNew.vue?vue&type=script&lang=js&"
export * from "./ActivityNew.vue?vue&type=script&lang=js&"
import style0 from "./ActivityNew.vue?vue&type=style&index=0&id=42338830&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42338830",
  null
  
)

export default component.exports